import { render, staticRenderFns } from "./InherentsLayout.vue?vue&type=template&id=25645dd8&scoped=true&"
import script from "./InherentsLayout.vue?vue&type=script&lang=js&"
export * from "./InherentsLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25645dd8",
  null
  
)

export default component.exports